var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronDoubleLeftColourful(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4BBFE",
    d: "M11.273 11.298l8.084-8.007a1 1 0 011.405-.005l.005.005.942.937a.986.986 0 010 1.397L15.307 12l6.4 6.375a.978.978 0 01.004 1.393l-.004.004-.944.937a1 1 0 01-1.405.005l-.005-.005-8.08-8.007a.992.992 0 010-1.404z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4350F7",
    d: "M3.291 11.298l8.084-8.007a1 1 0 011.405-.005l.005.005.942.937a.978.978 0 01.004 1.393l-.004.004L7.323 12l6.404 6.375a.986.986 0 010 1.397l-.944.937a1 1 0 01-1.405.005l-.005-.005-8.082-8.007a.992.992 0 010-1.404z"
  }))));
}

export default SvgChevronDoubleLeftColourful;